import { Dispatch, SetStateAction } from 'react';

const mergeStateWrapper = <S>(setState: Dispatch<SetStateAction<S>>) => (newVal: Partial<S>) =>
  setState(prevVal => ({ ...prevVal, ...newVal }));

export default mergeStateWrapper;
